<template>
  <PageWrapper>
    <template #content>
      <div class="container max-w-6xl mx-auto p-8 pb-24">
        <RecentActivity show-more show-filters class="mt-2" />
      </div>
    </template>
  </PageWrapper>
</template>

<script setup>
import { parseISO } from "date-fns";
import { computed, onMounted, ref } from "vue";
import PageWrapper from "@/components/PageWrapper.vue";
import RecentActivity from "@/components/RecentActivity.vue";
</script>
